import { makeStyles } from 'tss-react/mui';
import { FC, useEffect } from 'react';
import { RadioButtonChecked, RadioButtonUnchecked } from '@mui/icons-material';


type SelectItemProps = {
  selectItem?: string;
  items: {
    key: string
    value: string;
  }[];
  selectedIndex?: string;
  setSelectedIndex: (string: string | undefined) => void;
};

const CommonSelectItem: FC<SelectItemProps> = ({
  selectItem,
  items,
  selectedIndex,
  setSelectedIndex,
}) => {
  const { classes } = useStyles();

  useEffect(() => {
    if (selectItem) {
      setSelectedIndex(selectItem);
    }
  }, []);

  return (
    <>
      {
        items.map((item) => (
          <div className={classes.sectionContainer} key={item.key}>
            {selectedIndex === item.key ? (
              <div className={classes.iconButton}>
                <RadioButtonChecked style={{ color: '#E8192C', width: 24, height: 24 }} />
              </div>
            ) : (
              <div
                className={classes.iconButton}
                onClick={() => {
                  setSelectedIndex(item.key);
                }}
              >
                <RadioButtonUnchecked style={{ color: '#BABABA', width: 24, height: 24 }} />
              </div>
            )}
            <div className={classes.label}>{item.value}</div>
          </div>
        ))
      }
    </>
  );
};

export default CommonSelectItem;

const useStyles = makeStyles()((theme) => ({
  iconButton: {
    padding: 8,
  },
  sectionContainer: {
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: '#F0F0F0',
  },
  label: {
    padding: 16,
    fontSize: 14,
  },
}));